import { Controller } from "stimulus";
import $ from 'jquery';
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");

export default class extends Controller {
  static targets = [ "usersSelect"];
  
    connect() {
      
   this.element.querySelectorAll('.select2').forEach(select => {
         $(select).select2();
       }); 
  }

saveAll() {
  const rows = this.element.querySelectorAll('.nested-fields');
  let dashboards = [];
  let isValid = true;
  rows.forEach((row, index) => {
    const dashboardId = row.querySelector('input[name*="[id]"]')?.value.trim();
    const reportId = row.querySelector('input[name*="[report_id]"]')?.value.trim();
    const reportTitle = row.querySelector('input[name*="[report_title]"]')?.value.trim();
    const users = $(row.querySelector('select[name*="[users]"]')).val() || [];
    // === Empty field validation ===
    if (!reportId || !reportTitle) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: `Row ${index + 1}: Report ID and Report Title cannot be empty.`
      });
      isValid = false;
      return;
    }

    // === At least one role or user ===
    if (users.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: `Row ${index + 1}: At least one User must be selected.`
      });
      isValid = false;
      return;
    }

    dashboards.push({
      id: dashboardId || null, 
      report_id: reportId,
      report_title: reportTitle,
      users: users
    });
  });

  // Stop if invalid row
  if (!isValid || dashboards.length !== rows.length) return;

  // === Nothing to save ===
  
  if (dashboards.length === 0) {
    Swal.fire({
      icon: 'info',
      title: 'Nothing to Save',
      text: 'No dashboards to update or add.'
    });
    return;
  }

  // === Duplicate validation ===
  const ids = dashboards.map(d => d.report_id);
  const titles = dashboards.map(d => d.report_title);

  const duplicateIds = ids.filter((id, idx) => ids.indexOf(id) !== idx);
  const duplicateTitles = titles.filter((t, idx) => titles.indexOf(t) !== idx);

  if (duplicateIds.length > 0) {
    Swal.fire({
      icon: 'error',
      title: 'Duplicate Report IDs',
      text: `Found duplicates: ${duplicateIds.join(", ")}`
    });
    return;
  }

  if (duplicateTitles.length > 0) {
    Swal.fire({
      icon: 'error',
      title: 'Duplicate Report Titles',
      text: `Found duplicates: ${duplicateTitles.join(", ")}`
    });
    return;
  }

  // === Save to backend ===
  fetch(`/manage_system_dashboards`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({ system_dashboards: dashboards })
  })
  .then(res => res.json())
  .then(data => {
    Swal.fire({
      icon: 'success',
      title: 'Saved',
      text: 'Dashboards saved successfully!'
    });
  })
  .catch(err => {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong while saving.'
    });
  });
}

delete_dashboard(event) {
  event.preventDefault()

  const button = event.currentTarget
  const dashboardId = button.dataset.dashboardId
  const row = button.closest("tr")


  fetch(`/manage_system_dashboards/destroy_study_dashboard?dashboard_id=${dashboardId}`, {
  method: "DELETE",
  headers: {
    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
    "Accept": "application/json"
    }
  })
  .then(response => {
    if (response.ok) {
      row.remove();
    } else {
      alert("Failed to delete.");
    }
  });

}

}